import React, { useState, useCallback, useEffect } from 'react'
import { type Item, type TabsProps, type ItemProps } from './index.type'
const TabItem = <T,>({ item, isSelected, onPress }: ItemProps<T>) => {
  const { type, text } = item

  return (
      <div
        className={`flex-1 h-8 flex items-center border-transparent justify-center rounded-2.5 transition-colors ${isSelected
            ? 'bg-white text-black shadow-md border-[0.5px] border-solid !border-[#000000]/10'
            : 'bg-transparent text-black'
          }`}
        onClick={() => onPress(type)}
      >
        <span className="text-3.25 font-medium">{text}</span>
      </div>
    )
}

export default function Tabs<T = string>({ items, defaultSelected, onChange }: TabsProps<T>) {
  const [selectedType, setSelectedType] = useState<T>(defaultSelected || items[0]?.type)

  const handleItemPress = useCallback((type: T) => {
    setSelectedType(type)
  }, [])

  useEffect(() => {
    onChange(selectedType)
  }, [selectedType, onChange])

  return (
    <div className="bg-[#787880]/12 p-0.5 flex rounded-2.5">
      {items.map(item => (
        <TabItem
          key={String(item.type)}
          item={item}
          isSelected={selectedType === item.type}
          onPress={handleItemPress}
        />
      ))}
    </div>
  )
}